var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / close@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-close",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 11.500000) rotate(-45.000000) translate(-12.000000, -11.500000) translate(6.000000, 5.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6852824,6.46 L0.314397171,6.46 C0.232636549,6.45987825 0.154117507,6.41325472 0.0954631602,6.33 C0.0344365335,6.24337816 7.10542736e-14,6.12433689 7.10542736e-14,6 C7.10542736e-14,5.87566311 0.0344365335,5.75662184 0.0954631602,5.67 C0.154117507,5.58674528 0.232636549,5.54012175 0.314397171,5.54 L11.6852824,5.54 C11.767043,5.54012175 11.845562,5.58674528 11.9042164,5.67 C11.9647173,5.75718532 11.9991527,5.87582436 12,6 C11.9930184,6.24970205 11.8561207,6.44979549 11.6852824,6.46 Z",
    id: "Path",
    transform: "translate(6.000000, 6.000000) rotate(-270.000000) translate(-6.000000, -6.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6852824,6.46 L0.314397171,6.46 C0.232636549,6.45987825 0.154117507,6.41325472 0.0954631602,6.33 C0.0344365335,6.24337816 1.42108547e-14,6.12433689 1.42108547e-14,6 C1.42108547e-14,5.87566311 0.0344365335,5.75662184 0.0954631602,5.67 C0.154117507,5.58674528 0.232636549,5.54012175 0.314397171,5.54 L11.6852824,5.54 C11.767043,5.54012175 11.845562,5.58674528 11.9042164,5.67 C11.9647173,5.75718532 11.9991527,5.87582436 12,6 C11.9930184,6.24970205 11.8561207,6.44979549 11.6852824,6.46 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4fa7db3fa7ef5084a865c849778c7925.svg";
export { ForwardRef as ReactComponent };